
















import Vue from 'vue';
import LayerSelect from './LayerSelect.vue';
import LayerSelectToggle from './LayerSelectToggle.vue';
import { mapState } from "vuex";
import {
  RootState
} from "./../../store/types";
export default Vue.extend({
  name: 'LayerSelector',

  props: {
    layers: {
      type: Array,
      required: true,
      default: () => []
    },
    handleLayerSelect: {
      type: Function
    }
  },

  components: {
    LayerSelect,
    LayerSelectToggle
  },
  computed: {
    ...mapState({
      isLayerselectOpen: state => (state as RootState).isLayerselectOpen
    }),
    layersFiltered(){
      return this.layers.filter(function(layer) {
        return layer.name != ""
      })      
    }
  }
});
